import {NgModule} from '@angular/core';
import {SharedModule} from "../../common/shared.module";
import {TemplatesComponent} from "./templates/templates.component";
import {StudioAdsComponent} from "./studio-ads/studio-ads.component";
import {HomeComponent} from "./home.component";
import {NgxFlickingModule} from "@egjs/ngx-flicking";
import {SignageLibsModuleStudio, SignageLibsService} from '@signage/lib';

const declarations = [
    HomeComponent,
    StudioAdsComponent,
    TemplatesComponent
];

@NgModule({
    imports: [
        SharedModule, 
        NgxFlickingModule,
        SignageLibsModuleStudio
    ],
    declarations,
    exports: [],
    providers: [
        SignageLibsService
    ],
})

export class HomeModule {
}
